import React from "react";
import Slider from "@mui/material/Slider";
import { Sentiments } from "./ViewModels/Sentiments";
import SentimentFiltersViewModel from "./ViewModels/SentimentFiltersViewModel";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

interface ISentimentSliderProps<SentimentModel extends SentimentFiltersViewModel> {
    lable: string
    propertyName: string
    enabledValueName: string
    sentimentFilters: SentimentModel
    handleChangeInput: (name: string, value: any) => void
    setSentimentFilters: React.Dispatch<React.SetStateAction<SentimentModel>>
}

export default function SentimentSlider<SentimentModel extends SentimentFiltersViewModel>(props: ISentimentSliderProps<SentimentModel>) {
    const [sentimentValue, setSentimentValue] = React.useState<number[]>([0, 8]);

    React.useEffect(() => {
        //null if a preset was saved before new columns were added
        let holder: number[] = props.sentimentFilters[props.propertyName] === null ?
            [0, 8] :
            [
                Sentiments.indexOf(props.sentimentFilters[props.propertyName][0]),
                Sentiments.indexOf(props.sentimentFilters[props.propertyName][1]),
            ];
        setSentimentValue(holder)
    }, [])

    React.useEffect(() => {
        props.setSentimentFilters({
            ...props.sentimentFilters,
            [props.propertyName]: [Sentiments[sentimentValue[0]], Sentiments[sentimentValue[1]]],
        })
    }, [sentimentValue])

    function handleValueChange(event: Event, newValue: number | number[]) {
        //update the local values
        setSentimentValue(newValue as number[]);
    };

    return (
        <Grid container size={12} >
            <Grid size={12} >
                <FormControlLabel control={<Checkbox checked={props.sentimentFilters[props.enabledValueName]}
                    onChange={() => props.handleChangeInput(props.enabledValueName, !props.sentimentFilters[props.enabledValueName])} />}
                    label={props.lable} />
            </Grid>
            <Grid size={2} style={{ alignContent: 'center' }}>
                <Typography variant="body1">{Sentiments[sentimentValue[0]]}</Typography>
            </Grid>
            <Grid size={8} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }} >
                <Box sx={{ width: 320 }}>
                    <Slider
                        value={sentimentValue}
                        onChange={handleValueChange}
                        valueLabelDisplay="off"
                        max={8}
                        step={1}
                        disabled={!props.sentimentFilters[props.enabledValueName]}
                    />
                </Box>
            </Grid>
            <Grid size={2} style={{ alignContent: 'center' }}>
                <Typography style={{ marginLeft: '15px' }} variant="body1">{Sentiments[sentimentValue[1]]}</Typography>
            </Grid>
        </Grid>
    )
}